import { useTranslation } from 'react-i18next';
import React from 'react';
import { Typography } from '@material-ui/core';

import {
  BookingsItem,
  BookingsItemCaption,
  BookingsTotalNumbersWrapper,
  TabItemQuantity,
  TabItemTitle
} from './styles';

const EntityTabComponent = ({ title, selected, overview }) => {
  const [t] = useTranslation();

  const { total, available, expired } = overview || {};
  const color = selected ? 'primary' : 'inherit';

  return (
    <>
      <TabItemTitle variant="body1">{title}</TabItemTitle>

      <TabItemQuantity color={color}>{total}</TabItemQuantity>

      <BookingsTotalNumbersWrapper>
        <BookingsItem>
          <Typography color={color} variant="h2">
            {available}
          </Typography>

          <BookingsItemCaption variant="h3">{t('Active')}</BookingsItemCaption>
        </BookingsItem>

        <BookingsItem>
          <Typography color={color} variant="h2">
            {expired}
          </Typography>

          <BookingsItemCaption variant="h3">
            {t('Not active')}
          </BookingsItemCaption>
        </BookingsItem>
      </BookingsTotalNumbersWrapper>
    </>
  );
};

export default EntityTabComponent;
